import { api } from "./client";

export const HostCodesAPI = {
  getAllHostCodes: async () => {
    const { data } = await api.get("/api/v1/host-codes");
    return data;
  },

  createHostCode: async (payload) => {
    const { data } = await api.post("/api/v1/host-codes", payload);
    return data;
  },

  updateHostCode: async (code, payload) => {
    const { data } = await api.patch(`/api/v1/host-codes/${code}`, payload);
    return data;
  },

  deleteHostCode: async (code) => {
    await api.delete(`/api/v1/host-codes/${code}`);
  },

  /** Every code with its Instagram account, hosts and event counts, and what the owner repair changed. */
  getOverview: async () => {
    const { data } = await api.get("/api/admin/host-codes/overview");
    return data;
  },

  /** The events of one code: coming ones first, then the past ones. */
  getEvents: async (code) => {
    const { data } = await api.get(`/api/admin/host-codes/${encodeURIComponent(code)}/events`);
    return data;
  },
};
